import _defineProperty from "@babel/runtime/helpers/defineProperty";
/** @jsx jsx */

import { useContext } from 'react';
import { css, jsx } from '@emotion/core';
import { defaultGridColumnWidth, defaultLayout, spacingMapping, varColumnsNum } from './constants';
import { GridContext } from './grid-context';
/**
 * Maximum width styles for a grid using a fixed layout.
 *
 * Equal to the space occupied by the columns + the padding required.
 */

var getGridFixedLayoutMaxWidthStyles = function getGridFixedLayoutMaxWidthStyles(spacing) {
  return css({
    maxWidth: "calc(var(".concat(varColumnsNum, ") * ").concat(defaultGridColumnWidth, "px + ").concat(spacingMapping[spacing], "px)")
  });
};
/**
 * Horizontal padding for the grid.
 *
 * Not applied for nested grids as they should not be inset.
 */


var getGridPaddingStyles = function getGridPaddingStyles(spacing) {
  return css({
    padding: "0 ".concat(spacingMapping[spacing], "px")
  });
};

var getGridColumnGapStyles = function getGridColumnGapStyles(spacing) {
  return css({
    columnGap: spacingMapping[spacing]
  });
};

var gridFixedLayoutMaxWidthStyles = {
  cosy: getGridFixedLayoutMaxWidthStyles('cosy'),
  comfortable: getGridFixedLayoutMaxWidthStyles('comfortable'),
  compact: getGridFixedLayoutMaxWidthStyles('compact')
};
var gridFluidLayoutMaxWidthStyles = css({
  maxWidth: '100%'
});
var gridPaddingStyles = {
  cosy: getGridPaddingStyles('cosy'),
  comfortable: getGridPaddingStyles('comfortable'),
  compact: getGridPaddingStyles('compact')
};
var gridColumnGapStyles = {
  cosy: getGridColumnGapStyles('cosy'),
  comfortable: getGridColumnGapStyles('comfortable'),
  compact: getGridColumnGapStyles('compact')
};
var gridStyles = css({
  display: 'flex',
  boxSizing: 'border-box',
  margin: '0 auto',
  position: 'relative',
  alignItems: 'flex-start',
  flexWrap: 'wrap'
});
/**
 * __Grid__
 *
 * A container for one or more `GridColumn`.
 *
 * This is the internal component, which relies on the context provided by the
 * grid wrapper.
 *
 * @internal
 */

export var Grid = function Grid(_ref) {
  var _ref$layout = _ref.layout,
      layout = _ref$layout === void 0 ? defaultLayout : _ref$layout,
      testId = _ref.testId,
      children = _ref.children;

  var _useContext = useContext(GridContext),
      isNested = _useContext.isNested,
      columns = _useContext.columns,
      spacing = _useContext.spacing;

  return jsx("div", {
    css: [gridStyles, !isNested && gridPaddingStyles[spacing], layout === 'fixed' ? gridFixedLayoutMaxWidthStyles[spacing] : gridFluidLayoutMaxWidthStyles, gridColumnGapStyles[spacing]],
    style: _defineProperty({}, varColumnsNum, columns),
    "data-testid": testId
  }, children);
};